import Component from 'flarum/common/Component';
import Stream from 'flarum/utils/Stream';

import itemColor from "../common/util/itemColor";
import UserSubmitModal from './modal/UserSubmitModal';
import getDaysDifferent from "../common/util/getDaysDifferent";
import getItemUnit from "../common/util/getItemUnit";
import QueryManageConfirmationModal from './modal/QueryManageConfirmationModal';
import playVideoModal from "./modal/playVideoModal";
import generateJJXX from "../common/util/generateJJXX";

export default class QueryListItem extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    const {infoQueryData} = this.attrs;
    this.infoBaseData = infoQueryData.u2diBaseData();
    this.infoQueryData = infoQueryData;
    this.infoDetailsData = infoQueryData.u2diDetailsData();
    this.queryUserID = infoQueryData.userID();
    this.loading = false;
  }

  oncreate(){
    const _this = this;

    $("#u2diListContaced"+this.queryID).change(function(e) {
      const value = _this.infoContacted==1?0:1;
      app.modal.show(QueryManageConfirmationModal,{manageType:"contacted",manageValue:value,infoQueryData:_this.infoQueryData});
    }); 

    $("#u2diListCompleted"+this.queryID).change(function(e) {
      const value = _this.infoCompleted==1?0:1;
      app.modal.show(QueryManageConfirmationModal,{manageType:"completed",manageValue:value,infoQueryData:_this.infoQueryData});
    }); 
  }

  view() {
    const _this = this;
    const infoDetailsData = this.infoDetailsData;
    this.queryID = this.infoQueryData.id();
    this.userType = this.infoBaseData.userType();
    this.infoID = this.infoBaseData.id();
    this.infoSN = this.infoBaseData.sn();
    this.infoCategory = this.infoBaseData.category();
    this.infoReports = this.infoBaseData.reports();
    this.infoContacted = this.infoQueryData.contacted();
    this.infoCompleted = this.infoQueryData.completed();

    this.info_zcxx = JSON.parse(infoDetailsData.zcxx());
    this.info_ghtj = JSON.parse(infoDetailsData.ghtj());
    this.info_jjxx = JSON.parse(infoDetailsData.jjxx());
    this.info_lxxx = JSON.parse(CryptoJSAesJson.decrypt(infoDetailsData.lxxx(), (infoDetailsData.base_id()).toString()));
    this.u2diUserType9 = app.forum.attribute('u2diUserType9');

    const bilibiliLink = this.infoBaseData.bilibiliLink();
    const xdxx = JSON.parse(CryptoJSAesJson.decrypt(this.infoQueryData.xdxx(), (infoDetailsData.base_id()).toString()));

    const option_zcwz = this.info_zcxx.option_zcwz;
    this.infoType = this.infoBaseData.type();
    this.itemColor = itemColor(this.infoType);
    this.infoTypeText = app.translator.trans("ziven-u2di.forum.option-zclb-"+this.infoType);
    this.zsxm = xdxx.option_zsxm;
    this.zsxm_title = app.translator.trans("ziven-u2di.forum.option-zsxm-"+xdxx.option_zsxm_title);
    this.lxdh = xdxx.option_lxdh;

    this.tdmj = this.info_zcxx.option_tdmj;
    this.jzmj = this.info_zcxx.option_jzmj;
    this.zclb = app.translator.trans("ziven-u2di.forum.option-zclb-"+this.itemColor);
    this.zcwz = option_zcwz.name;
    this.position = option_zcwz.position;

    const infoStatus = this.infoBaseData.status();
    const infoPrice = this.infoBaseData.price();
    const infoFlag = this.infoBaseData.flag();
    const infoPriceUnit = getItemUnit(this.infoCategory,this.info_jjxx);
    const infoNid = this.infoQueryData.nID();
    const jjbl = infoStatus===2?"":"("+this.info_jjxx.option_jjbl+")";
    const infoSignedMark = this.infoBaseData.signedMark();
    
    const assignedAt = this.infoQueryData.assignedAt();
    const daysDifferents = getDaysDifferent(new Date().toISOString(),assignedAt);

    const showNew = daysDifferents<=3 && infoStatus===0;
    const unreadStyle = showNew?"margin-left:40px":"";

    const infoBottomStyle = infoStatus===0?"background: rgba("+this.itemColor+",.7)":"background:gray";
    const infoContacted = this.infoQueryData.contacted();
    const infoCompleted = this.infoQueryData.completed();
    const infoIcon = infoFlag===1?"fas fa-home":(this.infoCategory==="jzwz"?"fas fa-city":"fas fa-th-large");

    let reportType = null;

    if(this.infoReports>0){
      const reportData = this.infoQueryData.u2diReportData();
      reportType = reportData[reportData.length-1].type();
    }

    return (
      <div className="u2diInfoItemContainer">
        {window.selectedCategory==="rrrrrrr" && window.selectedTargetID===this.queryID && (
          <div className="u2diInfoIndicator"></div>
        )}
        <div className="u2diManageSideBarInfoData" onclick={(e) => { this.locateInfoOnMap() }}>
          {this.u2diUserType9===true && (
            <div style="padding-top: 5px;">
              <div className="u2diManageSideBarInfoRow1">
                <span style={infoStatus===2?"color:gray !important":"color: rgba("+this.itemColor+") !important"}><i className={infoIcon}></i></span>
                <span style="position:relative;">
                  {this.infoSN}

                  {showNew && (
                    <div className="u2diListItemLabel">
                      <div className="u2diLabelRed">NEW</div>
                    </div>
                  )}

                  {infoNid===null && (
                    <div style={unreadStyle} className="u2diListItemLabel">
                      <div style="padding:0px 5px;" className="u2diLabelOrange">{app.translator.trans('ziven-u2di.forum.item-unread')}</div>
                    </div>
                  )}
                </span>
                <span>
                  <div style="display:inline-block">{this.infoTypeText}</div>
                  {infoSignedMark===1 && (
                    <div style="margin-left: 5px;width: 14px;font-size: 14px;">
                      <i style="color: #04aa41;" class="fas fa-check-circle"></i>
                    </div>
                  )}
                  {bilibiliLink && (
                    <div style="cursor: pointer;margin-left: 5px;font-size: 14px;" onclick={(e)=>{e.preventDefault();e.stopPropagation();app.modal.show(playVideoModal,{link:bilibiliLink})}}>
                      <i style="margin-right: 5px;color: #00A1D6;" class="fas fa-play-circle"></i>
                    </div>
                  )}
                </span>
                <span className={"u2diListItemStatus"+infoStatus}>
                  {app.translator.trans('ziven-u2di.forum.item-status-'+infoStatus)}  <span style="color:gray;font-size: 12px;">{jjbl}</span>
                </span>
              </div>
              <div className="u2diManageSideBarInfoRow2">
                <span className="u2diEllipsisArea">{this.zcwz}</span>
                {this.infoReports>0 && infoStatus===0 && (
                  <span style={reportType===2?"background:#c82a29":"background:orange"}>{app.translator.trans("ziven-u2di.forum.item-report-"+reportType+"-reminder")}</span>
                )}
              </div>
              <div className="u2diManageSideBarInfoRow3">
                <div style="width:33%">
                  <span>{infoPrice}</span><span>{infoPriceUnit}</span>
                </div>
                <div style="width: 33%;">
                  <span style="position: relative;">{this.zsxm}
                    <div>{app.translator.trans("ziven-u2di.forum.user-type-query")}</div>
                  </span>
                  <span>{this.zsxm_title}</span>
                </div>
                <div style="width: 33%;text-align: right;">
                  <span>{this.lxdh}</span>
                </div>
              </div>
            </div>
          )}
        </div>
        <div id={"u2diManageSideBarInfoBottom"+this.queryID} style={infoBottomStyle} className="u2diManageSideBarInfoBottomData">
          <div style="text-align: left;display: flex;">
            <input type="checkbox" id={"u2diListContaced"+this.queryID} value={infoContacted} checked={infoContacted==1?"checked":""} />
            <label style="margin-left: 5px;" for={"u2diListContaced"+this.queryID}>{app.translator.trans('ziven-u2di.forum.item-contacted')}</label>
            <input style="margin-left: 10px;" type="checkbox" id={"u2diListCompleted"+this.queryID} value={infoCompleted} checked={infoCompleted==1?"checked":""} />
            <label style="margin-left: 5px;" for={"u2diListCompleted"+this.queryID}>{app.translator.trans('ziven-u2di.forum.item-completed')}</label>
          </div>
          <div style="text-align: right;">
            <span style="margin-right:10px;cursor:pointer" onclick={(e) => {
              generateJJXX("query",{
                infoBaseData:_this.infoBaseData,
                infoDetailsData:_this.infoDetailsData,
                queryUserID:_this.queryUserID,
              });
            }}>
              {app.translator.trans('ziven-u2di.forum.item-generate-jjxy')}
            </span>
            <span style="cursor:pointer" onclick={(e) => { this.viewDetails() }}>{app.translator.trans('ziven-u2di.forum.item-details')}</span>
          </div>
        </div>
      </div>
    );
  }

  locateInfoOnMap(){
    $(window).trigger('u2diLocateInfoOnMap', {
      position : new AMap.LngLat(this.position.lng,this.position.lat),
      itemID: this.infoID,
      targetID:this.queryID,
      dataType: "queryAdmin"
    });
  }

  viewDetails(){
    const wrapData = {
      selectedType:this.infoCategory,
      initType:"resume",
      viewType:"edit",
      from:"query",
      targetData: this.infoQueryData,
      reports:this.infoBaseData.reports(),
      option_zcqs: Stream(this.info_zcxx.option_zcqs),
      option_lzxz: Stream(this.info_zcxx.option_lzxz),
      option_lzxz_checked: Stream(this.info_zcxx.option_lzxz_checked),
      option_zclb: Stream(this.info_zcxx.option_zclb),
      option_zcwz: Stream(this.info_zcxx.option_zcwz),
      option_tdmj: Stream(this.info_zcxx.option_tdmj),
      option_jzmj: Stream(this.info_zcxx.option_jzmj),
      option_jzmj_disabled:Stream(this.info_zcxx.option_jzmj_disabled),
      option_synx: Stream(this.info_zcxx.option_synx),
      option_zcdb: Stream(this.info_zcxx.option_zcdb),
      option_zpzl: Stream(this.info_zcxx.option_zpzl),
      option_ystd: Stream(this.info_zcxx.option_ystd),

      option_ghtj: Stream(this.info_ghtj.option_ghtj),
      option_wjzl: Stream(this.info_ghtj.option_wjzl),
      option_ydmj: Stream(this.info_ghtj.option_ydmj),
      option_rjl: Stream(this.info_ghtj.option_rjl),
      option_ldl: Stream(this.info_ghtj.option_ldl),
      option_jzmd: Stream(this.info_ghtj.option_jzmd),
      option_jzxg: Stream(this.info_ghtj.option_jzxg),
      option_jzxg_disabled: Stream(this.info_ghtj.option_jzxg_disabled),

      // option_ysx: Stream(this.info_jjxx.option_ysx),
      // option_cjjg: Stream(this.info_jjxx.option_cjjg),
      option_crxs: Stream(this.info_jjxx.option_crxs),
      option_ssyq: Stream(this.info_jjxx.option_ssyq),
      option_ssyq_checked: Stream(this.info_jjxx.option_ssyq_checked),
      option_ysdj: Stream(this.info_jjxx.option_ysdj),
      option_yqjg: Stream(this.info_jjxx.option_yqjg),
      option_jjbl: Stream(this.info_jjxx.option_jjbl),
      option_zsyq: Stream(this.info_jjxx.option_zsyq),

      option_lxxx: Stream(this.info_lxxx.option_lxxx),
      option_bmqy: Stream(this.info_lxxx.option_bmqy),
      option_zjgw: Stream(this.info_lxxx.option_zjgw),
      option_zsxm: Stream(this.info_lxxx.option_zsxm),
      option_zsxm_title: Stream(this.info_lxxx.option_zsxm_title),
      option_lxdh: Stream(this.info_lxxx.option_lxdh),
      option_lxdh_checked: Stream(this.info_lxxx.option_lxdh_checked),
      option_lxdh_wx_value: Stream(this.info_lxxx.option_lxdh_wx_value),
      option_lxdh_wx_value_disabled: Stream(this.info_lxxx.option_lxdh_wx_value_disabled),
    };

    app.modal.show(UserSubmitModal,{wrapData});
  }
}